// CreateTicket.js
import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../../context/AuthContext';
import useTicketForm from '../../hooks/useTicketForm';
import { useState } from 'react';
// import { useTicketsContext } from '../../context/TicketContext';

export default function CreateTicket() {
  const { token } = useAuth();
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);
  // const { dispatch } = useTicketsContext();

  const {
    form,
    handleChange,
    handleFileChange,
    error,
    success,
    setError,
    setSuccess,
    resetForm,
    toFormData,
  } = useTicketForm();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    setIsSubmitting(true); // ✅ Disable the button

    try {
      const formData = toFormData();
      await axios.post(`${process.env.REACT_APP_API_URL}/api/tickets`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data',
        },
      });
      setSuccess('Ticket created successfully');
      resetForm();
    //  dispatch({ type: 'ADD_TICKET', payload: res.data });  //no need if navigating next as it will update on the useEffect at TicketList.js
      navigate('/tickets');
    } catch (err) {
      setError(err.response?.data?.message || 'Ticket creation failed');
    }
  };

  if (!token) return <p>Please log in to create a ticket.</p>;

  return (
    <div className="container mt-4">
      <h2>Create Ticket</h2>
      {error && <div className="alert alert-danger">{error}</div>}
      {success && <div className="alert alert-success">{success}</div>}
      {isSubmitting && <div className="alert alert-info">Please wait while the system is creating and e-mailing your ticket to IT...</div>}
      <form onSubmit={handleSubmit} encType="multipart/form-data">
        <div className="mb-3">
          <label className="form-label">Subject</label>
          <input
            type="text"
            name="subject"
            className="form-control"
            value={form.subject}
            onChange={handleChange}
            required
          />
        </div>
        <div className="mb-3">
          <label className="form-label">Description</label>
          <textarea
            name="description"
            className="form-control"
            value={form.description}
            onChange={handleChange}
            required
          ></textarea>
        </div>
        <div className="mb-3">
          <label className="form-label">Priority</label>
          <select
            name="priority"
            className="form-select"
            value={form.priority}
            onChange={handleChange}
          >
            <option>Low</option>
            <option>Medium</option>
            <option>High</option>
          </select>
        </div>
        <div className="mb-3">
          <label className="form-label">Attachments</label>
          <input
            type="file"
            name="attachments"
            className="form-control"
            multiple
            onChange={handleFileChange}
          />
        </div>
        <button type="submit" className="btn btn-primary" disabled={isSubmitting}>     
          Submit Ticket
        </button>
      </form>
      <Link to="/tickets" className="btn btn-sm btn-outline-secondary mt-2">Back</Link>
    </div>
  );
}
